import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme } from '@material-ui/core'

export const useWorkspaceEditorStyles = makeStyles((theme: Theme) => ({
    workspaceEditorContainer: {
        height: 'calc(100% - 52px)',
        overflowY: 'hidden',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        borderRadius: '8px 8px 0 0',
        backgroundColor: '#fff',
        '@media (max-width: 1024px)': {
            height: 'calc(100% - 200px)',
            width: 250,
            '& .wrappedDraggable': {
                minWidth: 450,
            },
        },
    },
    assemblyLabelContainer: {
        margin: 'auto',
        marginTop: theme.spacing(2),
        paddingRight: theme.spacing(1),
        maxWidth: pxToRem(550),
    },
    grayText: {
        color: theme.palette.grey[500],
        fontSize: pxToRem(14),
        textAlign: 'center',
    },
}))
